import React from 'react'
import { motion } from 'framer-motion'
import { transition1 } from '../transitions';

const Edition2 = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}
      className='lg:px-32 lg:py-10 p-14 mb-36 lg:mb-0'
    >
    <div className='lg:flex flex-2'>
        <div className='lg:h4 h5 flex-1'>
            Edition 02 <br/>
            22nd April 2025 <br/>
                      <p><hr className="border-t border-2 border-gray-800 my-6 w-1/3" /></p>

        </div>
        <div className='flex-1'>
            <p className='text-sm lg:pb-20'>For generations, philosophers, poets, and artists have wrestled to reclaim humanity’s story, defying the dominion of the thoughtsmiths who cast us as fallen—condemned, unworthy of freedom. In their defiance, artists envisioned humanity as sovereign, architects of destiny, free to choose its path.

But now, the very voices that once cried for freedom of choice murmur condemnation: “We have indeed drunk up the seas and erased the horizon. We have severed the earth from its sun.”

We, the heirs who once rejected the sins of our fathers, are now the progenitors of guilt. And now, our children will carry the weight of our trespasses, searching for redemption in the shadows of our choices. Yes, we have rewritten the story of the fall with the Anthropocene’s signature sin.

If the deepest existential trial of humanity was once to face the solitude of death, the new human faces something far graver: extinction. Where once, in the threshold of annihilation, the finite self found immortality in the enduring resonance of deeds and the seeds sown for futures unseen, now what will we become when the echoes are drowned by the wail of wars? When minds are hollowed by hunger? What becomes of our seeds when the soil lies barren, stripped of its promise?

No! The agony of the new age is not the solitude of separation from life’s thread—it is the unraveling of the thread itself. The fabric of existence frays into a void, and the quiet terror of nothingness waits at the edges of consciousness.

Does not a new epoch demand a new art? Shall art linger as a passive narrator, a lament for what is slipping away, or shall it rise as a force of intervention?

The Anthropocene asks of us something unprecedented: to transform art from a mirror of the human condition into a hammer that reshapes it. The art of this new era must transcend its traditional bounds. It must not only provoke thought but inspire movements. It must break free from galleries and pages, infiltrating the social, political, and environmental spheres to reverse this spiral of destruction. It must weave science, activism, and imagination into a tapestry of action.
<br/>
<br/>

<span className='font-bold'>Anahita Sahar Babaei</span>
</p>
        </div>
    </div>
    </motion.section>
  )
}

export default Edition2